<template>
    <div class="process">
        <h1>Process</h1>
        <p>
            A business process is sequence of business tasks that are either
            executed by humans or machines. In case of the later this can be
            software applications.
        </p>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "Process",
});
</script>
